module.exports = __webpack_public_path__ + "static/media/moneyconverter.0486a204.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/projetos/moneyconverter.png
// module id = 90
// module chunks = 0